// Types
import { useCallback } from "react";
import { TUseMemberCard } from "../Team.types";

const useMemberCard: TUseMemberCard = (
    restoreIconRef,
    member,
    setPersonInfo,
    setToggleShowWorkHistory,
    setAnchorEl,
    parentRef,
    type
) => {
    const onClickRestoreIcon = useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setToggleShowWorkHistory &&
                setToggleShowWorkHistory((currentState) => {
                    const initialPersonInfo = {
                        role: "",
                        id: -1,
                        info: undefined,
                        function: [],
                        hierarchy: null,
                    };
                    const newPersonInfo = {
                        role: member.role ? member.role : "",
                        id: member.person_id,
                        hierarchy: member.hierarchy,
                        function: member.function,
                    };

                    setPersonInfo && setPersonInfo(currentState ? initialPersonInfo : newPersonInfo);

                    return !currentState;
                });
            if (setAnchorEl) {
                setAnchorEl(event.currentTarget);
            }
        },
        [member, setAnchorEl, setPersonInfo, setToggleShowWorkHistory]
    );

    return onClickRestoreIcon;
};

export default useMemberCard;
